import { FunctionComponent } from 'react';
import { Col } from './col';
import { Row } from './row';
import { BwjGrid } from './grid';
import { BwjCard } from './card';
import { Spacing, useLayoutStyles } from './styles';

export interface IBwjFormSectionProps {
  heading?: string;
  className?: string;
}

export const BwjFormSection: FunctionComponent<IBwjFormSectionProps> = (props) => {
  const styles = useLayoutStyles();

  const heading = !!props.heading ? (
      <Row bottomSpacing={Spacing.Large}>
          <Col small={12}>
              <h3 className={styles.formSectionHeading}>{props.heading}</h3>
          </Col>
      </Row>
  ) : null;

  return (
    <BwjCard className={props.className}>
        <BwjGrid>
            {heading}
            {props.children}
        </BwjGrid>
    </BwjCard>
  );
};